import * as yup from "yup";

export const feedActionSchema = yup.object().shape({
  type: yup.string().oneOf(["URL", "GLEAP"]).required(),
  label: yup.string(),
  action: yup.string().required(),
});

export interface FeedAction extends yup.InferType<typeof feedActionSchema> {}
